let messages = {
    _default: (field) => `The value is not valid.`,
    _invalid_format: (field, {format}) => `The field must be in the format ${format}.`,
    _atLeastOneRule: (field) => `At least one validation rule has to be met:`,

    equals(field, {other, isField = false}) {
        let target = isField
                        ? '"' + this.form().getFieldLabel(other) + '" field'
                        : other

        return `The field must be equal to ${target}.`
    },
    contains: (field, {target}) => `The field must contain "${target}".`,
    has: (field, {data}) => {
        let dataFormatted = isArray(data) ? data.join(', ') : data
        return `The field must contain the following values: ${dataFormatted}.`
    },
    hasOne: (field, {data}) => {
        let dataFormatted = isArray(data) ? data.join(', ') : data
        return `The field must contain at least one of the following values: ${dataFormatted}.`
    },
    startsWith: (field, {target}) => `The field must starts with "${target}".`,
    endsWith: (field, {target}) => `The field must ends with "${target}".`,
    after(field, {target, inclusion}) {
        target = getTarget(this.form(), target)
        if( false === target ) {
            return `Please fill "${target}" field first.`
        }
        return `The field must be after ${inclusion ? 'or equal to ' : ''}${target}.`
    },
    alphadash: (field) => `The field may contain alpha-numeric characters as well as dashes and underscores.`,
    alphanumeric: (field) => `The field may only contain alpha-numeric characters.`,
    alphaspaces: (field) => `The field may only contain alphabetic characters as well as spaces.`,
    alpha: (field) => `The field may only contain alphabetic characters.`,
    before(field, {target, inclusion}) {
        target = getTarget(this.form(), target)
        if( false === target ) {
            return `Please fill "${target}" field first.`
        }
        return `The field must be before ${inclusion ? 'or equal to ' : ''}${target}.`
    },
    between: (field, {from, to}) => `The field must be between ${from} and ${to}.`,
    dateBetween(field, {from, to}) {
        from = getTarget(this.form(), from)
        if( false === from ) {
            return `Please fill "${from}" field first.`
        }

        to = getTarget(this.form(), to)
        if( false === from ) {
            return `Please fill "${to}" field first.`
        }

        return `The field must be between ${from} and ${to}.`
    },
    datetimeBetween(field, {from, to}) {
        return messages.dateBetween.bind(this)(field, {from, to})
    },
    date: (field, {format}) => `The field must be in the format ${format}.`,
    time: (field, {format}) => `The field must be in the format ${format}.`,
    datetime: (field, {format}) => `The field must be in the format ${format}.`,
    decimal: (field, {decimals = '*'} = {}) => `The field must be numeric and may contain ${!decimals || decimals === '*' ? '' : decimals} decimal points.`,
    digits: (field, {length}) => `The field must be numeric and contain exactly ${length} digits.`,
    email: (field) => `The field must be a valid email.`,
    in: (field, {data}) => `The field must be equal to one of the following values: ${data.join(', ')}.`,
    integer: (field) => `The field must be an integer.`,
    ip: (field) => `The field must be a valid ip address.`,
    maxlength: (field, {length}) => `The field may not be greater than ${length} characters.`,
    max: (field, {max}) => `The field must be ${max} or less.`,
    minlength: (field, {length}) => `The field must be at least ${length} characters.`,
    min: (field, {min}) => `The field must be ${min} or more.`,
    numeric: (field) => `The field may only contain numeric characters.`,
    match: (field) => `The field format is invalid.`,
    required: (field) => `The field cannot be empty.`,
    url: (field) => `The field is not a valid URL.`,

    // opposite
    not_equals(field, {other, isField = false}) {
        let target = isField
                        ? '"' + this.form().getFieldLabel(other) + '" field'
                        : other

        return `The field cannot be equal to ${target}.`
    },
    not_contains: (field, {target}) => `The field cannot contain "${target}".`,
    not_has: (field, {data}) => {
        let dataFormatted = isArray(data) ? data.join(', ') : data
        return `The field cannot contain the following values: ${dataFormatted}.`
    },
    not_hasOne: (field, {data}) => {
        let dataFormatted = isArray(data) ? data.join(', ') : data
        return `The field cannot contain one of the following values: ${dataFormatted}.`
    },
    not_startsWith: (field, {target}) => `The field cannot starts with "${target}".`,
    not_endsWith: (field, {target}) => `The field cannot ends with "${target}".`,
    not_after(field, {target, inclusion}) {
        target = getTarget(this.form(), target)
        if( false === target ) {
            return `Please fill "${target}" field first.`
        }
        return `The field cannot be after ${inclusion ? 'or equal to ' : ''}${target}.`
    },
    not_alphadash: (field) => `The field cannot contain any alpha-numeric characters as well as dashes and underscores.`,
    not_alphanumeric: (field) => `The field cannot contain any alpha-numeric characters.`,
    not_alphaspaces: (field) => `The field cannot contain any alphabetic characters as well as spaces.`,
    not_alpha: (field) => `The field cannot contain any alphabetic characters.`,
    not_before(field, {target, inclusion}) {
        target = getTarget(this.form(), target)
        if( false === target ) {
            return `Please fill "${target}" field first.`
        }
        return `The field cannot be before ${inclusion ? 'or equal to ' : ''}${target}.`
    },
    not_between: (field, {from, to}) => `The field cannot be between ${from} and ${to}.`,

    not_dateBetween(field, {from, to}) {
        from = getTarget(this.form(), from)
        if( false === from ) {
            return `Please fill "${from}" field first.`
        }

        to = getTarget(this.form(), to)
        if( false === from ) {
            return `Please fill "${to}" field first.`
        }

        return `The field cannot be between ${from} and ${to}.`
    },
    not_datetimeBetween(field, {from, to}) {
        return messages.not_dateBetween.bind(this)(field, {from, to})
    },
    not_decimal: (field, {decimals = '*'} = {}) => `The field cannot be numeric and cannot contain ${!decimals || decimals === '*' ? '' : decimals} decimal points.`,
    not_digits: (field, {length}) => `The field cannot be numeric and cannot be exactly ${length} digits.`,
    not_in: (field, {data}) => `The field cannot be equal to any of the following values: ${data.join(', ')}.`,
    not_integer: (field) => `The field cannot be an integer.`,
    not_numeric: (field) => `The field cannot contain any numeric characters.`
}

function getTarget(form, target) {
    if( form.has(target) ) {
        let targetValue = form.get(target)

        if( isEmpty(targetValue) ) {
            target = form.getFieldLabel(target)
            return false
        }

        target = targetValue
    }

    return target
}

export default messages
